var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bookingEntry"},[_c('h3',[_vm._v(_vm._s(_vm.$store.getters.l.privateSuccessHeader))])])}
var staticRenderFns = []

export { render, staticRenderFns }